/* eslint-disable no-dupe-keys */
import { Box, Typography, Button, Tooltip, TextField, InputAdornment } from '@mui/material'
import React, { useState } from 'react'
import RadioBoxGroup from '../../../components/RadioButtons/RadioBoxGroup'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SearchIcon from '@mui/icons-material/Search';
import ProjectTable from './ProjectTable'
import { wrap } from 'highcharts';

const Projects = () => {

    const [activeTab, setActiveTab] = useState('default');

    return (
        <>
            <Box
                sx={{
                    overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
                    maxWidth: '100%',
                }}
            >
                <Box
                    display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                    }}
                >
                    <Button onClick={() => setActiveTab('default')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px',
                        borderRadius: '100px',
                        backgroundColor: activeTab === 'default' ? '#0076FE' : '#fff',
                        color: activeTab === 'default' ? '#fff' : '#64748B',
                        border: activeTab === 'default' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 500,
                        fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                        },
                    }}>
                        Default project role
                    </Button>

                    <Button onClick={() => setActiveTab('complete')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px',
                        borderRadius: '100px',
                        backgroundColor: activeTab === 'complete' ? '#0076FE' : '#fff',
                        color: activeTab === 'complete' ? '#fff' : '#64748B',
                        border: activeTab === 'complete' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 500,
                        fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                        },
                    }}>
                        Complete to-dos setting
                    </Button>

                    <Button onClick={() => setActiveTab('edittab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px',
                        borderRadius: '100px',
                        backgroundColor: activeTab === 'edittab' ? '#0076FE' : '#fff',
                        color: activeTab === 'edittab' ? '#fff' : '#64748B',
                        border: activeTab === 'edittab' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 500,
                        fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                        },
                    }}>
                        Edit & Delete to-dos setting
                    </Button>
                </Box>
            </Box>


            <Box>
                <CustomTabPanel value={activeTab} index="default">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Default project role
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Upon initiating a new project, team members will automatically be allocated to the chosen role.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['None', 'Views', 'User', 'Manager']}
                            defaultValue="None"
                            row={true}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <ProjectTable />
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="complete">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Permission to complete to-dos
                            <Tooltip title="This setting controls who can mark tasks/to-dos as complete. Selecting 'Management only' restricts this action to managers." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Enable all users to complete to-dos within projects, or restrict this ability to management roles only (org owners and org managers).</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Default
                            <Tooltip title="Organization default: Applies this setting to all current and future members automatically." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['Everyone', 'Management Only']}
                            defaultValue="Everyone"
                            row={true}
                        />
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="edittab">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Permission to edit & delete to-dos
                            <Tooltip title="Controls who can edit or delete tasks/to-dos. When set to 'Management only,' only managers can make these changes." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Allow all users to edit or delete to-dos, or limit these actions to management roles only (org owners and org managers).</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Default
                            <Tooltip title="Organization default: Applies to all members by default." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['Everyone', 'Management Only']}
                            defaultValue="Everyone"
                            row={true}
                        />
                    </Box>
                </CustomTabPanel>
            </Box>


        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box sx={{ padding: { xl: '16px 5px', lg: '15px 0', md: '15px 0', sm: '15px  0', sx: '15px 0' } }}>{children}</Box>;
};


export default Projects
